import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative w-100 h-100 flex-grow-1" };
const _hoisted_2 = { class: "position-absolute overflow-auto start-0 end-0 top-0 bottom-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
        ])
    ]));
}
